import React from 'react';

const EmptyGraphData = ({ message }) => (
  <div className="empty-graph-data">{message}</div>
);

export default EmptyGraphData;
